import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { StorageKeys } from '@shared/modules/storage/core/storage-keys.enum';
import { browserTracingIntegration, init, replayIntegration } from '@sentry/angular';
import { loadConfig } from './config';

init({
  dsn: environment.sentryDns,
  environment: environment.name,
  release: `ads-manager@${environment.app_version}`,
  integrations: [
    browserTracingIntegration(),
    replayIntegration(),
  ],
  tracePropagationTargets: ['localhost'],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (!localStorage.getItem(StorageKeys.CURRENT_LOCALE)) {
  // localStorage.setItem(StorageKeys.CURRENT_LOCALE, supportedLanguages.includes(navigator?.language as Languages) ? navigator.language : 'en');
  localStorage.setItem(StorageKeys.CURRENT_LOCALE, 'en');
}


async function initialize() {
  if (environment.production) {
    enableProdMode();
  }

  const appModuleContainer = await import('./app/app.module');

  platformBrowserDynamic()
    .bootstrapModule(appModuleContainer.AppModule)
    // eslint-disable-next-line no-console
    .then(() => console.log('Bootstrap success'))
    // eslint-disable-next-line no-console
    .catch(err => console.error(err));
}

loadConfig().finally(initialize);
